export default __webpack_public_path__ + "static/media/tostart2.71113c80.svg";